import { useLocationSuggest } from './useLocationSuggest';
import { useLocationSuggestValue } from './useLocationSuggestValue';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getGeo } from '../../../../selectors/geo';
import { useHandleReloadPopularRegions } from './useHandleReloadPopularRegions';

/**
 * Хук оборачивает хук саджеста и используется в мобильной версии выбора региона
 * Вместо хука попапа useLocationSearchMobile использует состояние isSuggestShown
 * Есть кейсы, при которых саджест показывается - например когда мы стираем символы
 * Для этого проверяется дополнительно длинна строки поиска
 */
export const useLocationSearchMobile = () => {
  const { locations, isError, isFetching } = useSelector(getGeo);

  /** Вместо попапа с**/
  const [isSuggestShown, setIsSuggestShown] = useState(false);

  const handleRetry = useHandleReloadPopularRegions();

  const {
    getLocationSuggest,
    suggest: foundLocations,
    isFetching: isSearching,
  } = useLocationSuggest({
    togglePopup: setIsSuggestShown,
  });

  const { suggestValue: searchValue, onSuggestionValueChange: onSearchValueChange } = useLocationSuggestValue({
    togglePopup: setIsSuggestShown,
    getLocationSuggest,
  });

  /**
   * Разделяем полученные регионы на два блока
   * API популярных регионов возвращает первыми двумя регионами Москву с МО и Питер с Лен областью
   */
  const specialLocations = useMemo(() => (locations ? locations.slice(0, 2) : []), [locations]);
  const allLocations = useMemo(() => (locations ? locations.slice(2) : []), [locations]);

  return {
    isLoading: isSearching || isFetching,
    isSearchShown: Boolean(searchValue) && isSuggestShown,
    searchValue,
    onSearchValueChange,
    handleRetry,
    isError,
    foundLocations,
    specialLocations,
    locations: allLocations,
    setIsSuggestShown,
  };
};
